import { render, staticRenderFns } from "./GroupRobot.vue?vue&type=template&id=c82f7690&scoped=true&"
import script from "./GroupRobot.vue?vue&type=script&lang=js&"
export * from "./GroupRobot.vue?vue&type=script&lang=js&"
import style0 from "./GroupRobot.vue?vue&type=style&index=0&id=c82f7690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82f7690",
  null
  
)

export default component.exports